import { Dialog, Flex, Text, Box, Progress, Button } from "@radix-ui/themes";
import { Cross2Icon } from "@radix-ui/react-icons";
import type { ZipProgress } from "../../../lib/zip-generator";

interface DownloadProgressProps {
  open: boolean;
  progress: ZipProgress | null;
  supplierName: string;
  error: string | null;
  onCancel: () => void;
  onClose: () => void;
}

export function DownloadProgress({
  open,
  progress,
  supplierName,
  error,
  onCancel,
  onClose,
}: DownloadProgressProps) {
  const isComplete = progress?.percentage === 100;

  return (
    <Dialog.Root open={open}>
      <Dialog.Content
        maxWidth="450px"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => {
          // Only allow escape if there's an error or complete
          if (!error && !isComplete) {
            e.preventDefault();
          }
        }}
      >
        <Flex justify="between" align="center" mb="4">
          <Dialog.Title>
            {error
              ? "Download Failed"
              : isComplete
                ? "Download Complete"
                : "Downloading..."}
          </Dialog.Title>
          {(error || isComplete) && (
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "4px",
              }}
            >
              <Cross2Icon width={20} height={20} />
            </button>
          )}
        </Flex>

        <Box mb="4">
          <Text size="2" color="gray" mb="2" as="div">
            {supplierName}
          </Text>
        </Box>

        {error ? (
          <Box>
            <Text color="red" size="2" as="div" mb="4">
              {error}
            </Text>
            <Flex justify="end">
              <Button onClick={onClose}>Close</Button>
            </Flex>
          </Box>
        ) : (
          <>
            <Box mb="3">
              <Progress value={progress?.percentage ?? 0} size="3" />
            </Box>

            <Flex justify="between" align="center">
              <Text size="2" color="gray">
                {progress?.step ?? "Preparing..."}
              </Text>
              <Text size="2" weight="medium">
                {progress?.percentage ?? 0}%
              </Text>
            </Flex>

            {!isComplete && (
              <Flex justify="end" mt="4">
                <Button variant="soft" color="gray" onClick={onCancel}>
                  Cancel
                </Button>
              </Flex>
            )}
          </>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
}
